<template>
  <div class="list-container">
    <DxList
      ref="dxList"
      :data-source="rumusSource"
      :height="heightList"
      :search-enabled="true"
      search-mode="contains"
      search-expr="gaji_item.nama"
    >
      <template #item="{ data }">
        <div>
          <strong>{{ data.gaji_item.nama }}</strong>
        </div>
        <div>
          {{ data.rumus }}
        </div>
      </template>
    </DxList>
  </div>
</template>

<script>
import DxList from "devextreme-vue/list";
import { computed } from "vue";
export default {
  components: {
    DxList,
  },
  props: {
    gajiSkemaId: {
      type: Number,
      required: true,
    },
    heightList: {
      type: Number,
      default: 800,
    },
    gajiSkemaKomponenStore: {
      type: Array,
      default: () => [],
    },
  },
  setup(props) {
    const rumusSource = computed(() => {
      // return _.filter(commonStore.gajiSkemaKomponenStore, (item) => {
      //   return _.get(item, "gaji_skema_id") === props.gajiSkemaId;
      // });
      return props.gajiSkemaKomponenStore;
    });

    return {
      rumusSource,
    };
  },
};
</script>
